import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Login from '../components/auth/Login';
import Dashboard from '../components/dashboard/Dashboard';
import AdminDashboard from '../components/admin/AdminDashboard';
import CustomerList from '../components/admin/customers/CustomerList';
import CouponList from '../components/admin/coupons/CouponList';
import CouponFormContainer from '../components/admin/coupons/CouponFormContainer';
import CouponDesignerWrapper from '../components/admin/coupons/CouponDesignerWrapper';
import CouponAnalytics from '../components/admin/coupons/CouponAnalytics';
import AssetList from '../components/admin/assets/AssetList';
import CouponLanding from '../components/public/CouponLanding/CouponLanding';
import CouponRedemptionContainer from '../components/public/CouponRedemption/CouponRedemptionContainer';
import Settings from '../components/admin/Settings/Settings';
import Reports from '../components/admin/reports/Reports';
import ProtectedRoute from '../components/routing/ProtectedRoute';
import Layout from '../components/layout/Layout';
import PublicLayout from '../components/public/PublicLayout';
import { useAuth } from '../contexts/AuthContext';

const AppRoutes: React.FC = () => {
    const { isAuthenticated, user } = useAuth();

    return (
        <Routes>
            {/* Public routes */}
            <Route
                path="/"
                element={
                    isAuthenticated ? (
                        <Navigate to={user?.role === 'admin' ? '/admin/dashboard' : '/dashboard'} />
                    ) : (
                        <Navigate to="/login" />
                    )
                }
            />
            
            {/* Login page */}
            <Route path="/login" element={<Login />} />
            
            {/* Public Coupon Pages - Using PublicLayout for analytics */}
            <Route element={<PublicLayout />}>
                <Route path="/c/:couponId" element={<CouponLanding />} />
                <Route path="/r/:couponId/:email/:subscriberId" element={<CouponRedemptionContainer />} />
            </Route>

            {/* Protected routes */}
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Layout>
                            <Dashboard />
                        </Layout>
                    </ProtectedRoute>
                }
            />

            {/* Admin routes */}
            <Route
                path="/admin"
                element={
                    <ProtectedRoute requireAdmin>
                        <Layout>
                            <Outlet />
                        </Layout>
                    </ProtectedRoute>
                }
            >
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="customers" element={<CustomerList />} />
                <Route path="coupons" element={<CouponList />} />
                <Route path="coupons/new" element={<CouponFormContainer />} />
                <Route path="coupons/:id/edit" element={<CouponFormContainer />} />
                <Route path="coupons/:id/design" element={<CouponDesignerWrapper />} />
                <Route path="coupons/:id/analytics" element={<CouponAnalytics />} />
                <Route path="assets" element={<AssetList />} />
                <Route path="reports" element={<Reports />} />
                <Route path="settings" element={<Settings />} />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRoutes;
